import * as Types from './types';

export interface PathType {
  path: string[];
  type: Types.Type;
}

export function allObjPaths(objectType: Types.ObjectType): PathType[] {
  const paths: PathType[] = [];
  for (const key of Object.keys(objectType.propertyTypes)) {
    const propType = objectType.propertyTypes[key];
    if (!Types.isSimpleType(propType)) {
      const objType = (propType.type === 'object'
        ? propType
        : propType.type === 'union'
        ? propType.members.find(
            m => m && !Types.isSimpleType(m) && m.type === 'object'
          )
        : undefined) as Types.ObjectType | undefined;
      if (objType != null) {
        for (const subPath of allObjPaths(objType)) {
          paths.push({type: subPath.type, path: [key].concat(subPath.path)});
        }
      } else {
        paths.push({type: propType, path: [key]});
      }
    } else {
      paths.push({type: propType, path: [key]});
    }
  }
  return paths;
}
